:host {
    --ir-object-fit: fill;
    --ir-object-position: inherit;
    --ir-width: 100%;
    --ir-height: auto;
    --ir-max-width: none;
    --ir-max-height: none;
    --ir-aspect-ratio: inherit;


    display: block;
}

img {
    object-fit: var(--ir-object-fit);
    object-position: var(--ir-object-position);
    font-family: 'object-fit';
    display: block;
    width: var(--ir-width);
    height: var(--ir-height);
    max-width: var(--ir-max-width);
    max-height: var(--ir-max-height);
    aspect-ratio: var(--ir-aspect-ratio);
}
